// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oj-1";
export var messageSideRight = "_oj-2";
export var orderLookupBubbleContainer = "_oj-0";
export var submitButton = "_oj-3";